import { IApplicationState } from '../../types/redux';

export function getIsAuthenticated(state: IApplicationState) {
  return Boolean(state.user);
}
